module.exports = __webpack_public_path__ + "static/media/japanese-speaking-training.cdc9f747.gif";